module.exports = __webpack_public_path__ + "img/gestao-municipal-ba.bb902eb6.png";